import { PRODUCTS_BUSINESS_ENDPOINT } from 'common/constants/endpoints'
import { request } from 'common/utils'

import { ProductQuery } from '../interfaces/schemaDefinition'

import query from './product.graphql'

export const getProduct = async (id: string): Promise<ProductQuery['product']> =>
  (await request<ProductQuery>(PRODUCTS_BUSINESS_ENDPOINT, query, { id })).product
